module.exports = __webpack_public_path__ + "img/save.15d967c5.svg";